import React from "react";
import PropTypes from "prop-types";
import { get } from "dot-prop-immutable";
import { Link } from "react-router-dom";

import PermissionsSwitch from "components/library/PermissionsSwitch";
import WithPermissions from "components/library/WithPermissions";
import placeholder from "assets/img/user-placeholder.png";
import classNames from "classnames";

import styles from "./UserRow.css";

export function ReducedUserRow({ user, className }) {
  let profPic = placeholder;
  try {
    profPic = get(user, "photo.crops.1x1.url");
  } catch (e) {
    // Fallback to placeholder
  }

  return (
    <div className={classNames(styles.user, className)}>
      {/* Use background-image for performance */}
      <div
        className={styles.pic}
        style={{ backgroundImage: `url(${profPic})` }}
      />
      <span className={styles.name}>
        {user.display_name && user.display_name.length > 1
          ? user.display_name
          : user.username}
      </span>
      {user.job_title && <span className={styles.title}>{user.job_title}</span>}
    </div>
  );
}

export default function UserRow({ user }) {
  return (
    <div className={styles.root}>
      <PermissionsSwitch>
        <WithPermissions required={["users.change_user"]}>
          <Link to={`user/${user.username}`} className={styles.linked}>
            <ReducedUserRow user={user} className={styles.tableChild} />
          </Link>
        </WithPermissions>
        <WithPermissions>
          <ReducedUserRow user={user} className={styles.tableChild} />
        </WithPermissions>
      </PermissionsSwitch>
    </div>
  );
}

UserRow.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string,
    photo: PropTypes.shape({
      crops: PropTypes.shape({
        "1x1": PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
    display_name: PropTypes.string,
    job_title: PropTypes.string,
  }).isRequired,
};
